<template>
  <div
    id="alert-message"
    class="alert-bar-container"
  >
    <transition-group
      name="alert-bar"
      tag="div"
    >
      <div
        v-for="(alert, index) in alerts"
        :key="alert.message"
        class="alert-bar"
      >
        <div class="alert-bar__icon">
          <img :src="alert.alertIcon" />
        </div>
        <div class="alert-bar__message">
          {{ alert.message }}
        </div>
        <span
          class="alert-bar__close"
          @click="closeBar(index)"
          v-html="closeIcon"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
import successIcon from '@/assets/success-alert.svg'
import failIcon from '@/assets/fail-alert.svg'
import feather from 'feather-icons'

const VISIBILITY_DURATION = 6000
export default {
  name: 'AlertBar',
  props: ['data'],
  data() {
    return {
      successIcon: successIcon,
      failIcon: failIcon,
      closeIcon: feather.icons.x.toSvg({width: '50%'}),
      alerts: [],
    }
  },
  watch: {
    data: function () {
      this.showAlert()
    },
  },
  methods: {
    /*
     * Don't show more than one of the same message.
     * Don't show a message if session expired already exists.
     */
    showAlert() {
      const existingAlert = this.alerts.findIndex((alert) => {
        return (
          alert.message === this.data.message
          || alert.message === 'Your session has expired, please sign in again.'
        )
      })
      if (existingAlert === -1) {
        this.alerts.push({
          message: this.data.message,
          type: this.data.type,
          alertIcon: this.data.type === 'success' ? successIcon : failIcon,
        })
      }
      setTimeout(() => {
        this.alerts.shift()
      }, VISIBILITY_DURATION)
    },
    closeBar(index) {
      this.alerts.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-bar {
  @include flex-display();
  @include flex-justify-content(space-between);
  background: $black;
  border-radius: 5px;
  padding: 14px 16px;
  min-width: 400px;
  color: $white;
  margin: 1em;
  @media #{$mobile} {
    min-width: 100%;
    margin: 0;
    box-sizing: border-box;
    border-radius: 0;
    padding: 1em;
  }
  &-container {
    @include flex-display();
    @include flex-direction(column-reverse);
    min-width: 400px;
    z-index: 1050;
    position: fixed;
    bottom: 0;
    right: 0;
    @media #{$mobile} {
      min-width: 100%;
      box-sizing: border-box;
    }
  }
  &__message {
    @include flex-display();
    @include flex-align-items(center);
    flex-grow: 1;
  }
  &__icon {
    @include flex-display();
    @include flex-justify-content(center);
    @include flex-align-items(center);
    margin-right: 1em;
  }
  &__close {
    @include flex-display();
    @include flex-justify-content(center);
    @include flex-align-items(center);
    margin-left: 1.5em;
    cursor: pointer;
    width: 35px;
    height: 35px;
    color: $grey-text;
    &:hover {
      background: darken($dark-grey, 10%);
      border-radius: 33px;
    }
  }
}
</style>
